
import globalEventListeners from '@/mixins/globalEventListeners';

export default {
  mixins: [globalEventListeners],
  props: {
    moreInfoBanner: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    // console.log("created")
    this.addGlobalEventListeners();


  },
  methods: {
    trackMoreInfoClick() {
      if (this.$gtm && this.$gtm.sendLeadRedirectEvent) {
        const label =
          (this.moreInfoBanner && this.moreInfoBanner.button && this.moreInfoBanner.button.label) ||
          'Daha Fazla Bilgi Al'
        this.$gtm.sendLeadRedirectEvent(label)
      }
    },
  },
}
